var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE1E7",
    fillRule: "nonzero",
    d: "M47 0C21.15 0 0 21.15 0 47s21.15 47 47 47 47-21.15 47-47S72.85 0 47 0zm0 14.1c7.99 0 14.1 6.11 14.1 14.1 0 7.99-6.11 14.1-14.1 14.1-7.99 0-14.1-6.11-14.1-14.1 0-7.99 6.11-14.1 14.1-14.1zm0 66.74c-11.75 0-22.09-6.11-28.2-15.04 0-9.4 18.8-14.57 28.2-14.57 9.4 0 28.2 5.17 28.2 14.57-6.11 8.93-16.45 15.04-28.2 15.04z"
  }))));
};
export { SvgAccount as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdmlld0JveD0iMCAwIDk2IDk2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iNDciIGN5PSI0NyIgcj0iNDciIGZpbGw9IiNGRkYiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjREJFMUU3IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik00NyAwQzIxLjE1IDAgMCAyMS4xNSAwIDQ3czIxLjE1IDQ3IDQ3IDQ3IDQ3LTIxLjE1IDQ3LTQ3UzcyLjg1IDAgNDcgMHptMCAxNC4xYzcuOTkgMCAxNC4xIDYuMTEgMTQuMSAxNC4xIDAgNy45OS02LjExIDE0LjEtMTQuMSAxNC4xLTcuOTkgMC0xNC4xLTYuMTEtMTQuMS0xNC4xIDAtNy45OSA2LjExLTE0LjEgMTQuMS0xNC4xem0wIDY2Ljc0Yy0xMS43NSAwLTIyLjA5LTYuMTEtMjguMi0xNS4wNCAwLTkuNCAxOC44LTE0LjU3IDI4LjItMTQuNTcgOS40IDAgMjguMiA1LjE3IDI4LjIgMTQuNTctNi4xMSA4LjkzLTE2LjQ1IDE1LjA0LTI4LjIgMTUuMDR6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";